import { Link } from 'react-router-dom'
import { FiArrowRight, FiClock } from 'react-icons/fi'
import { resolveMediaUrl } from '../services/api'

export default function ServiceCard({ service, minimal = false }) {
  const imageUrl = resolveMediaUrl(service.imageUrl)

  if (minimal) {
    return (
      <article className="surface-card overflow-hidden">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img src={imageUrl} alt={service.name} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />
          <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-stone-700">
            {service.category}
          </span>
        </div>
        <div className="p-6">
          <h3 className="font-heading text-3xl text-stone-900">{service.name}</h3>
          <p className="mt-3 text-sm leading-7 text-stone-600">{service.description}</p>
          <div className="mt-5 flex items-center justify-between text-sm font-semibold text-stone-700">
            <span className="text-2xl text-rose-700">${service.price.toFixed(0)}</span>
            <span className="inline-flex items-center gap-2 rounded-full bg-stone-100 px-3 py-2">
              <FiClock />
              {service.durationMinutes} min
            </span>
          </div>
        </div>
      </article>
    )
  }

  return (
    <article className="surface-card overflow-hidden">
      <div className="relative aspect-[4/3] overflow-hidden">
        <img src={imageUrl} alt={service.name} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-6 text-white">
          <p className="text-xs uppercase tracking-[0.22em] text-white/75">{service.category}</p>
          <h3 className="mt-2 font-heading text-4xl leading-none">{service.name}</h3>
        </div>
      </div>
      <div className="p-8">
        <p className="text-sm leading-7 text-stone-600">{service.description}</p>

        <div className="mt-6 grid gap-3 text-sm sm:grid-cols-2">
          <div className="rounded-3xl bg-stone-100 px-4 py-4">
            <p className="text-xs uppercase tracking-[0.18em] text-stone-500">Duration</p>
            <p className="mt-2 font-semibold text-stone-900">{service.durationMinutes} minutes</p>
          </div>
          <div className="rounded-3xl bg-rose-50 px-4 py-4">
            <p className="text-xs uppercase tracking-[0.18em] text-stone-500">Starting at</p>
            <p className="mt-2 font-semibold text-rose-700">${service.price.toFixed(2)}</p>
          </div>
        </div>

        <Link
          to="/booking"
          className="primary-button mt-6 inline-flex w-full items-center justify-center gap-2"
        >
          <span>Book This Service</span>
          <FiArrowRight />
        </Link>
      </div>
    </article>
  )
}
